// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__ouc7a","btnOffer":"AddProduct_btnOffer__jQWKM"};